import { render } from "./HeadComponent.vue?vue&type=template&id=580f5af9&scoped=true"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=580f5af9&lang=css"
import "./HeadComponent.vue?vue&type=style&index=1&id=580f5af9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f5af9"]])

export default __exports__